import { render, staticRenderFns } from "./platformRepairSessions.vue?vue&type=template&id=4573a762&scoped=true"
import script from "./platformRepairSessions.vue?vue&type=script&lang=js"
export * from "./platformRepairSessions.vue?vue&type=script&lang=js"
import style0 from "./platformRepairSessions.vue?vue&type=style&index=0&id=4573a762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573a762",
  null
  
)

export default component.exports